import { Theme } from 'config';

const styles = (theme: Theme) => ({
  legend: {
    textAlign: 'center !important',
  },
  legendRow: {
    padding: '0 0 1.750rem 0 !important',
  },
  crosshairTop: {
    top: 0,
    width: '1.25rem',
    height: '0.0625rem',
    backgroundColor: theme.darkGray,
  },
  crosshairBottom: {
    position: 'absolute',
    width: '1.25rem',
    height: '0.0625rem',
    background: theme.darkGray,
  },
  '@global .rv-crosshair__inner--right': {
    left: '-0.625rem',
  },
  '@global .rv-crosshair__inner--left': {
    right: '-0.625rem',
  },
});

export default styles;
